export const acceptableMktParams = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "campaign_lookup",
  "adgroup_lookup",
  "ad_lookup",
  "placement_lookup",
  "ad_placement",
  "feid",
  "tgid",
  "loci",
  "locp",
  "maty",
  "ntwk",
  "devc",
  "kywd",
  "plcm",
  "tagt",
  "aid",
  "gclid",
  "fbclid",
  "epik",
  "wbraid",
  "gbraid",
  "dclid",
  "gclsrc",
  "_gl",
  "duid",
  "tpn_click_id",
  "tpn_widget_id",
  "tpn_ref_domain",
  "tpn_publisher_name",
  "ttclid",
  "r_site",
  "r_adzone",
  "r_campaign",
  "r_banner",
  "r_country",
  "r_country_id",
  "r_city",
  "r_region",
  "r_carrier",
  "r_device",
  "r_device_type",
  "r_os",
  "r_os_name",
  "r_language",
  "r_language_code",
  "r_conversion",
  "r_keywords",
  "r_keywords_matched",
  "r_sub_id",
  "_raclid",
  "r_creative",
  "fb_audience",
  "dvcm",
  "creative",
  "adgroupid",
  "campaign_id",
  "cid",
  "asset_group",
  "dodo",
  "r_sub_id",
  "tbid", // taboola
  "msclkid",
]

export const TRACKING_PARAMS = new Set(acceptableMktParams)

export const acceptableClickIds = new Set([
  "_raclid",
  "alart", // applovin
  "aleid", // applovin
  "dclid",
  "dodo",
  "epik",
  "fbclid",
  "gbraid",
  "gclid",
  "gclsrc",
  "msclkid",
  "r_conversion",
  "tbid", // taboola
  "tpn_click_id",
  "ttclid",
  "wbraid",
])
